import { render, staticRenderFns } from "./BlankLayout.vue?vue&type=template&id=ca0cbd9c"
import script from "./BlankLayout.vue?vue&type=script&lang=js"
export * from "./BlankLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/private/workspaces/smart-life/smart-life-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ca0cbd9c')) {
      api.createRecord('ca0cbd9c', component.options)
    } else {
      api.reload('ca0cbd9c', component.options)
    }
    module.hot.accept("./BlankLayout.vue?vue&type=template&id=ca0cbd9c", function () {
      api.rerender('ca0cbd9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/BlankLayout.vue"
export default component.exports